/* eslint-disable react/jsx-curly-newline */
import '@resources/fontes/fontes.css'
import '@resources/css/cardsample/cardsample.css'
import React from 'react'
import { Card } from 'react-bootstrap'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'
import { IoTrash } from 'react-icons/io5'
import Photo from '@resources/imgs/mask-group-2.png'
import LogoProssed from '@resources/imgs/logo-proseed-2.png'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Link } from 'react-router-dom'
import New from '@resources/imgs/icon-new.svg'
import LogoEuropean from '@resources/imgs/european.webp'
import LogoSeattle from '@resources/imgs/seattle.png'
import Ovulos from '@resources/imgs/tratament-2.png'
import Embriao from '@resources/imgs/tratament-1.png'
import Trompas from '@resources/imgs/tratament-3.png'

interface CardSampleProps {
  hasProperty: boolean
  canDrag: boolean
  canSelect: boolean
  item: any
  size: boolean
  selectedTreatments?: any
  handleUnfavorite?: (id: string) => void
  handleMoveUp?: (id: string | number) => void
  handleMoveDown?: (id: string | number) => void
}
const CardSample: React.FC<any> = ({ canSelect, hasProperty, canDrag, item, selectedTreatments, handleUnfavorite, handleMoveUp, handleMoveDown }: CardSampleProps) => {

  const { listeners, setNodeRef, transform, transition } = useSortable({ id: item.id })
  const isTreatmentEligible = !selectedTreatments || selectedTreatments?.includes(item.treatment)
  return (
    <div className="col-12 col-md-6 col-lg-4 box-card"
      ref={setNodeRef}
      {...listeners}
      style={{
        transform: CSS.Transform.toString(transform),
        transition: transition
      }}
    >
      <Card className={`donator-card ${isTreatmentEligible ? 'border-none' : 'border-red'}`}>
        <Card.Body className="card-body-donator d-flex flex-column align-items-center gap-10">
          <div className="d-flex align-items-center justify-content-between h-100 w-100 gap-5">
            <figure className="img-user">
              <img src={item.avatar || Photo} alt="" />
              {item?.is_new_donor ? (
                <div className="icon-new">
                  <img src={New} alt="" />
                </div>
              ) : null}
            </figure>
            <div className="d-flex justify-content-between h-100 pr-0 flex-grow-1">
              <div className="d-flex align-items-start align-items-xl-center justify-content-center flex-column flex-xl-row">
                <div className="d-flex flex-column justify-content-start">
                  <div id="dados" className="d-flex justify-content-between">
                    <Link to={`/doadores/${item.internal_id?.toLowerCase()}`} target="_blank" className="text-decoration-none">
                      <div className="id"><b>ID: {item.internal_id}</b></div>
                    </Link>
                    <div className="d-flex align-items-center">
                      {canSelect && (
                        <div className="check mx-1">
                          <input type="checkbox" className="donor-checkbox" name="select" id="select" />
                        </div>
                      )}
                      {hasProperty && (
                        <div className="priority mx-1">
                        Prioridade
                          <span>{item.id}</span>
                        </div>
                      )}
                      {canDrag && (
                        <div className="move-item">
                          <button className="icon" onClick={() => handleMoveUp?.(item.id)}>
                            <IoIosArrowUp />
                          </button>
                          <button className="icon" onClick={() => handleMoveDown?.(item.id)}>
                            <IoIosArrowDown />
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <small className="amostra">{item?.sperm_bank?.name === 'Pro-Seed' ? 'Amostra Nacional' : 'Amostra Internacional'}</small>
                  </div>
                  {item.occupation ? (
                    <div>
                      <div className="amostra">{item.occupation}</div>
                    </div>
                  ) : null}
                  {item.nickname ? (
                    <div>
                      <div className="amostra">{item.nickname}</div>
                    </div>
                  ) : null}
                  {!isTreatmentEligible && (
                    <p className="not-eligible">Doador incompátivel</p>
                  )}
                </div>
                <div className="d-flex align-items-center justify-content-center flex-column flex-1 ml-0 ml-xl-3">
                  <div className="tratament-logo d-flex align-items-center justify-content-start gap-10">
                    <figure className="mb-0">
                      {item?.sperm_bank?.name === 'Pro-Seed' ? (
                        <img src={LogoProssed} alt="" />
                      ) : item?.sperm_bank?.name === 'European Sperm Bank' ? (
                        <img src={LogoEuropean} alt="" />
                      ) : item?.sperm_bank?.name === 'Seattle Sperm Bank' ? (
                        <img src={LogoSeattle} alt="" />
                      ) : (
                        <img src={LogoProssed} alt="" />
                      )}
                    </figure>
                  </div>
                </div>
              </div>
              <button className="icons trash-icon mx-1 border-0" onClick={() => handleUnfavorite?.(item.internal_id)}>
                <IoTrash />
              </button>
            </div>
          </div>
          {item?.available_treatment_names && item?.available_treatment_names?.length > 0 ? (
            <div className="row w-100">
              {item?.available_treatment_names.includes('ICSI') ? (
                <div className="col-4 result d-flex flex-column justify-content-between text-center">
                  <div className="d-flex align-items-center justify-content-center gap-5">
                    <img src={Ovulos} alt="" />
                    <span>ICSI</span>
                  </div>
                  {item.icsi_price ? (
                    <span className="treatment-values">R$ {item.icsi_price}</span>
                  ) : (
                    <span className="treatment-values">Valor Indefinido</span>
                  )}
                </div>
              ) : null}
              {item?.available_treatment_names.includes('FIV') ? (
                <div className="col-4 result d-flex flex-column justify-content-between gap-2 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-5 mr-2">
                    <img src={Embriao} alt="" />
                    <span>FIV</span>
                  </div>
                  {item.fiv_price ? (
                    <span className="treatment-values">R$ {item.fiv_price}</span>
                  ) : (
                    <span className="treatment-values">Valor Indefinido</span>
                  )}
                </div>
              ) : null}
              {item?.available_treatment_names.includes('IIU') ? (
                <div className="col-4 result d-flex flex-column justify-content-between gap-2 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-5">
                    <img src={Trompas} alt="" />
                    <span>Inseminação</span>
                  </div>
                  {item.iiu_price ? (
                    <span className="treatment-values">R$ {item.iiu_price}</span>
                  ) : (
                    <span className="treatment-values">Valor Indefinido</span>
                  )}
                </div>
              ) : null}
            </div>
          ) : (
            <div className="row w-100">
              <div className="col-12 result d-flex flex-column justify-content-between text-center">
                <span className="treatment-values">Doador indisponível</span>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  )
}

export default CardSample
